<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/purchaseOrders/add')">新增</el-button>
        <el-button type="primary" v-if="hasExport" @click="exportYcnPurchaseOrder">导出采购统计</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item label="订单ID" prop="orderId">
          <el-input v-model.trim="searchForm.orderId" placeholder="请输入订单ID" clearable />
        </el-form-item>
        <el-form-item label="合同标题" prop="orderTitle">
          <el-input v-model.trim="searchForm.orderTitle" placeholder="请输入订单标题" clearable />
        </el-form-item>
        <el-form-item label="品种规格" prop="specName">
          <el-input v-model.trim="searchForm.specName" placeholder="请输入品种规格" clearable />
        </el-form-item>
        <el-form-item label="供应商" prop="supplierName">
          <el-input v-model.trim="searchForm.supplierName" placeholder="请输入供应商名称" clearable />
        </el-form-item>
        <el-form-item label="订单状态" prop="orderState">
          <el-select :clearable="true" v-model="searchForm.orderState" placeholder="请选择订单状态">
            <el-option v-for="[key, value] of ycOrderStateMap" :label="value" :value="key" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="180" label="订单ID" prop="orderId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="订单类型" prop="orderType">
          <template v-slot="{ row }">
            {{ orderTypeMap.get(row.orderType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="采购方" prop="purchaserName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="采购类型" prop="purchaserType">
          <template v-slot="{ row }">
            {{ purchaserTypeMap.get(row.purchaserType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="合同标题" prop="orderTitle"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="合同编号" prop="orderNum"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="供应商名称" prop="supplierName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="付款方式" prop="">
          <template v-slot="{ row }">
            {{ orderPriceMap.get(row.orderPrice) || '--' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="订单状态">
          <template v-slot="{ row }">
            {{ ycOrderStateMap.get(row.orderState) }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" min-width="280">
          <template v-slot="{ row }">
            <el-button v-if="row.orderState === '2' && hasChild" type="text"
              @click="$router.push(`/purchaseOrders/add?orderParent=${row.orderId}&orderType=${row.orderType}&purchaser=${row.purchaser}&supplierId=${row.supplierId}&purchaserType=${row.purchaserType}`)">拆分子订单</el-button>
            <el-button v-if="row.orderState === '2' && hasEnd" type="text" @click="endRow(row.orderId)">结束订单</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/purchaseOrders/edit?orderId=' + row.orderId)">编辑</el-button>
            <el-button type="text" @click="$router.push('/purchaseOrders/detail?orderId=' + row.orderId)">详情</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.orderId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { orderType, orderPrice, ycOrderState, purchaserType } from '@/utils/dict'
import { downloadExcelFile } from '@/utils/globalMethods'
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'PurchaseOrders',
  mixins: [keepAlive],
  data() {
    return {
      ycOrderStateMap: ycOrderState,
      orderTypeMap: orderType,
      orderPriceMap: orderPrice,
      purchaserTypeMap: purchaserType,
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        orderId: '',
        orderTitle: '',
        specName: null,
        supplierName: null,
        orderState: ''
      },
      // 1粮油2物料
      typeArr: [
        {
          label: '粮油',
          value: '1'
        },
        {
          label: '物料',
          value: '2'
        }
      ]

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasChild() {
      return this.buttonList.includes('child')
    },
    hasEnd() {
      return this.buttonList.includes('end')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    userInfo() {
      return this.$store.state.user
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    exportYcnPurchaseOrder() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios.post(this.$apis.purchaseOrders.exportYcnPurchaseOrder, {
        ...this.searchForm,
        createUserId: this.userInfo.userId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          downloadExcelFile(res.data, '采购订单统计')
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByList, {
        params: {
          page: this.page,
          ...this.searchForm,
          createUserId: this.userInfo.userId
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        purchaseType: null,
        orderId: null,
        bidId: null,
        specId: null
      }
      this.onSearch()
    },

    deleteRow(orderId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseOrders.deleteYcPurchaseOrder, {
          orderId
        }).then(() => {
          this.loadData()
        })
      })
    },
    endRow(orderId) {
      this.$confirm('确认结束该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseOrders.approveYcnPurchaseOrder, {
          orderId,
          orderState: '3'
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;

  .num {
    color: #007bff;
    margin-right: 15px;

  }
}
</style>
